// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as Reactfire from "reactfire";
import * as ArrayUtils from "../../utils/ArrayUtils.bs.jsx";
import * as ReactUpdate from "rescript-react-update/src/ReactUpdate.bs.jsx";
import * as Stdlib_Null from "@rescript/runtime/lib/es6/Stdlib_Null.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Firestore from "rxfire/firestore";
import * as Firestore$1 from "firebase/firestore";

let initialState = {
  continueWith: undefined,
  data: undefined,
  error: undefined,
  pending: false
};

function getConstraints(limit, startAfter) {
  let basicConstraints = [
    Firestore$1.where("depletedAt", "!=", null),
    Firestore$1.orderBy("depletedAt", "desc"),
    Firestore$1.limit(limit + 1 | 0)
  ];
  if (startAfter !== undefined) {
    return basicConstraints.concat([Firestore$1.startAfter(Stdlib_Null.getOrThrow(startAfter.depletedAt))]);
  } else {
    return basicConstraints;
  }
}

function compareKegs(keg1, keg2) {
  if (keg1.serial === keg2.serial) {
    return Stdlib_Null.map(keg1.depletedAt, prim => prim.toMillis()) === Stdlib_Null.map(keg2.depletedAt, prim => prim.toMillis());
  } else {
    return false;
  }
}

function concatenateResponse(extra, extra$1, extra$2) {
  return ArrayUtils.unionByPreferringLast(compareKegs, extra, extra$1, extra$2);
}

function kegQuerySnapshotToKegs(kegsSnapshot) {
  return kegsSnapshot.docs.map(prim => Firestore.snapToData(prim, { "idField": "uid" }));
}

function use(limitOpt, placeId) {
  let limit = limitOpt !== undefined ? limitOpt : 20;
  let firestore = Reactfire.useFirestore();
  let kegsCollectionRef = Db.placeKegsCollectionConverted(firestore, placeId);
  let match = ReactUpdate.useReducer((state, action) => {
    if (typeof action !== "object") {
      if (action === "FetchMore") {
        let lastKeg = state.continueWith;
        if (lastKeg !== undefined && state.data !== undefined && !state.pending) {
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              continueWith: state.continueWith,
              data: state.data,
              error: state.error,
              pending: true
            },
            _1: param => {
              let send = param.send;
              let constraints = getConstraints(limit, lastKeg);
              Stdlib_Promise.$$catch(Firestore$1.getDocs(Firestore$1.query(kegsCollectionRef, ...constraints)).then(kegsSnapshot => {
                let data = kegQuerySnapshotToKegs(kegsSnapshot);
                send({
                  TAG: "FetchMoreSuccess",
                  _0: data
                });
                return Promise.resolve();
              }), error => {
                send({
                  TAG: "LoadingError",
                  _0: error
                });
                return Promise.resolve();
              });
            }
          };
        }
      } else {
        let exit = 0;
        if (state.continueWith !== undefined || state.data !== undefined) {
          exit = 2;
        } else {
          if (!state.pending) {
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                continueWith: state.continueWith,
                data: state.data,
                error: state.error,
                pending: true
              },
              _1: param => {
                let send = param.send;
                let constraints = getConstraints(limit, undefined);
                Stdlib_Promise.$$catch(Firestore$1.getDocs(Firestore$1.query(kegsCollectionRef, ...constraints)).then(kegsSnapshot => {
                  let data = kegQuerySnapshotToKegs(kegsSnapshot);
                  send({
                    TAG: "InitialLoadSuccess",
                    _0: data
                  });
                  return Promise.resolve();
                }), error => {
                  send({
                    TAG: "LoadingError",
                    _0: error
                  });
                  return Promise.resolve();
                });
              }
            };
          }
          exit = 2;
        }
        if (exit === 2) {
          if (state.data !== undefined) {
            if (!state.pending) {
              return "NoUpdate";
            }
          } else if (state.pending) {
            return "NoUpdate";
          }
        }
      }
    } else {
      switch (action.TAG) {
        case "FetchMoreSuccess" :
          let previousData = state.data;
          if (previousData !== undefined) {
            let newData = action._0;
            return {
              TAG: "Update",
              _0: {
                continueWith: newData[limit],
                data: concatenateResponse(undefined, previousData, newData),
                error: undefined,
                pending: false
              }
            };
          }
          break;
        case "InitialLoadSuccess" :
          let data = action._0;
          return {
            TAG: "Update",
            _0: {
              continueWith: data[limit],
              data: data,
              error: undefined,
              pending: false
            }
          };
        case "LoadingError" :
          return {
            TAG: "Update",
            _0: {
              continueWith: state.continueWith,
              data: state.data,
              error: action._0,
              pending: false
            }
          };
      }
    }
    console.log("unhandled state and action", {
      state: state,
      action: action
    });
    return "NoUpdate";
  }, initialState);
  let paginatedDataSend = match[1];
  let paginatedDataState = match[0];
  React.useEffect(() => {
    paginatedDataSend("InitialLoad");
  }, []);
  if (paginatedDataState.continueWith !== undefined) {
    let data = paginatedDataState.data;
    if (data !== undefined) {
      return [
        data.slice(0, -1),
        () => paginatedDataSend("FetchMore")
      ];
    } else {
      return [
        undefined,
        undefined
      ];
    }
  }
  let data$1 = paginatedDataState.data;
  if (data$1 !== undefined) {
    return [
      data$1,
      undefined
    ];
  } else {
    return [
      undefined,
      undefined
    ];
  }
}

export {
  initialState,
  getConstraints,
  compareKegs,
  concatenateResponse,
  kegQuerySnapshotToKegs,
  use,
}
/* Db Not a pure module */
